import css from 'styled-jsx/css';

const styles = css`.other-income-field-set .other-income-header{display:flex;justify-content:space-between;align-items:center}.primary-income-row{padding-bottom:1rem}`;

export default styles;